{
	"fetchError": "Failed to load carbon reductions for cycle"
}
